<svg style="margin-left: -3px; margin-bottom: 3px" class="mt-2" *ngIf="showLoader"
     role="img"
     width="100%"
     height="210"
     aria-labelledby="loading-aria"
     viewBox="0 0 400 210"
     preserveAspectRatio="none"
>
    <title id="loading-aria">Loading...</title>
    <rect
            x="0"
            y="0"
            width="100%"
            height="100%"
            clip-path="url(#clip-path)"
            style='fill: url("#fill");'
    ></rect>
    <defs>
        <clipPath id="clip-path">
            <rect x="3" y="4" rx="3" ry="3" width="52" height="43"/>
            <circle cx="352" cy="25" r="13"/>
            <rect x="68" y="4" rx="3" ry="3" width="260" height="43"/>
            <circle cx="386" cy="25" r="13"/>
            <rect x="3" y="57" rx="3" ry="3" width="52" height="43"/>
            <circle cx="352" cy="78" r="13"/>
            <rect x="68" y="57" rx="3" ry="3" width="260" height="43"/>
            <circle cx="386" cy="78" r="13"/>
            <rect x="3" y="112" rx="3" ry="3" width="52" height="43"/>
            <circle cx="352" cy="133" r="13"/>
            <rect x="68" y="112" rx="3" ry="3" width="260" height="43"/>
            <circle cx="386" cy="133" r="13"/>
            <rect x="3" y="165" rx="3" ry="3" width="52" height="43"/>
            <circle cx="352" cy="186" r="13"/>
            <rect x="68" y="165" rx="3" ry="3" width="260" height="43"/>
            <circle cx="386" cy="186" r="13"/>
        </clipPath>
        <linearGradient id="fill">
            <stop
                    offset="0.599964"
                    stop-color="#f3f3f3"
                    stop-opacity="1"
            >
                <animate
                        attributeName="offset"
                        values="-2; -2; 1"
                        keyTimes="0; 0.25; 1"
                        dur="2s"
                        repeatCount="indefinite"
                ></animate>
            </stop>
            <stop
                    offset="1.59996"
                    stop-color="#cac8c8"
                    stop-opacity="1"
            >
                <animate
                        attributeName="offset"
                        values="-1; -1; 2"
                        keyTimes="0; 0.25; 1"
                        dur="2s"
                        repeatCount="indefinite"
                ></animate>
            </stop>
            <stop
                    offset="2.59996"
                    stop-color="#f3f3f3"
                    stop-opacity="1"
            >
                <animate
                        attributeName="offset"
                        values="0; 0; 3"
                        keyTimes="0; 0.25; 1"
                        dur="2s"
                        repeatCount="indefinite"
                ></animate>
            </stop>
        </linearGradient>
    </defs>
</svg>
<div class="clearfix"></div>
<div *ngIf="!showLoader" class="col-md-12 no-padding mt-2">
    <ul class="list-group">
        <li class="list-group-item no-border"
            [ngClass]="{'wd-list-activity': acty.automatic_activity !==true,
             'wd-list-activity-automatic':acty.automatic_activity !==undefined && acty.automatic_activity==true }"

            *ngFor="let acty of totalActivities">
            <div class="col-md-12 no-padding">
                <div class="col-md-2 no-padding"><b>Trajanje</b> <br>{{acty.activityDuration}}</div>
                <div class="col-md-4 no-padding text-center"><b>Početak</b>
                    <br> {{acty.start | date:'dd.MM.yyyy HH:mm'}}</div>
                <div class="col-md-4 no-padding text-center"><b>Kraj</b> <br> {{acty.end | date:'dd.MM.yyyy HH:mm'}}
                </div>
                <div class="col-md-2 no-padding text-right">
                    <button class="btn btn-sm btn-light"
                            [disabled]="acty.automatic_activity !==undefined && acty.automatic_activity==true"
                            (click)="deleteActivity(acty)">
                        <span role="button" class="fa fa-trash"></span></button>
                    <button class="btn btn-sm btn-light" [disabled]="acty.from_proventum==true" (click)="edit(acty)">
                        <span role="button" class="fa fa-edit"></span></button>

                </div>
            </div>
            <div class="col-md-12 no-padding mt-3">
                <label style="font-weight: 600">Projekat:</label>
                {{acty.project_id !== "" && acty.project_id !== null ? acty.project.name : '/'}}
            </div>
            <div class="col-md-12 no-padding">
                <label style="font-weight: 600">Zadatak: </label>
                {{acty.task_id !== '' && acty.task_id !== null && acty.task !== null ? acty.task.title : '/'}}
            </div>
            <div class="col-md-12 no-padding mt-2">
                <label style="font-weight: 600">Opis:</label> {{acty.comment !== '' ? acty.comment : '/'}}
            </div>
            <div class="col-md-12 no-padding mt-2">
                <label style="font-weight: 600">Tip:</label> {{acty.type.name}}
            </div>
        </li>
    </ul>

</div>
<div *ngIf="!showLoader" class="col-md-12 no-padding mb-3 mt-3">
    <button class="btn btn-sm btn-light wd-add-new-line" (click)="open()"><i class="fa fa-plus mr-1"></i>
        aktivnost
    </button>
</div>
